import React, { useContext } from 'react';
import { ModifyPlaylistButton } from '@atlassian/ai-audio/ui/buttons';

import { fg } from '@confluence/feature-gating';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';
import { PageCardContext } from '../PageCardContext';
import { withFlags } from '@confluence/flags/entry-points/withFlags';

const WrappedButton = ({ flags }) => {
	const { cloudId } = useSessionData();
	const { id, type, title } = useContext(PageCardContext);

	return (
		cloudId &&
		fg('confluence_audio_briefings_v3') && (
			<ModifyPlaylistButton
				cloudId={cloudId}
				contentId={id}
				contentType={type}
				title={title.text}
				flags={flags}
			/>
		)
	);
};

export const AudioPlaylistButton = withFlags(WrappedButton);
